export default "__VITE_ASSET__d3427e24__"